<template>
  <div>
    <div class="sidebar-container" :style="menuReduced">
      <div
        class="sidebar-logo pb-2 d-flex flex-column justify-center align-center"
      >
        <div class="d-flex flex-column justify-center align-center">
          <router-link
            to="/dashboard"
            class="d-flex justify-center flex-column align-center"
          >
            <span class="pb-md-5">
              <img src="../../static/logo/empiricus.svg" />
            </span>
          </router-link>
          <span v-if="openMenu" style="color: var(--white)"
            >Dashboard Gambit</span
          >
        </div>
      </div>
      <ul class="sidebar-navigation pl-0" v-if="openMenu">
        <span class="header">SMS e Push App</span>
        <li
          :class="
            this.$route.path === '/envio-mensagem' ? 'active-navigation' : ''
          "
        >
          <router-link to="/envio-mensagem" class="d-flex align-center">
            <i class="iconMenu icon-sms" />
            <span> Enviar</span>
          </router-link>
        </li>
        <li
          :class="
            this.$route.path === '/scheduling-web' ||
            this.$route.path === '/duplicate'
              ? 'active-navigation'
              : ''
          "
        >
          <router-link to="/scheduling-web" class="d-flex align-center">
            <i class="iconMenu icon-calendar" />
            <span> Agendamentos e Logs</span>
          </router-link>
        </li>
        <li
          :class="
            this.$route.path === '/lista-de-envios'
              ? 'active-navigation'
              : ''
          "
        >
          <router-link to="/lista-de-envios" class="d-flex align-center">
            <i class="iconMenu icon-list" />
            <span> Listas de envio</span>
          </router-link>
        </li>
        <span class="header">PUSH WEB</span>
        <li
          :class="
            this.$route.path === '/enviar-notificacao'
              ? 'active-navigation'
              : ''
          "
        >
          <router-link to="/enviar-notificacao" class="d-flex align-center">
            <i class="iconMenu icon-bell" />
            <span> Enviar notificações</span>
          </router-link>
        </li>
        <li
          :class="
            this.$route.path === '/agendamentos' ? 'active-navigation' : '' ||
            this.$route.path === '/duplicate-push-web'
              ? 'active-navigation'
              : ''
          "
        >
          <router-link to="/agendamentos" class="d-flex align-center">
            <i class="iconMenu icon-calendar" />
            <span>Agendamentos e Logs</span>
          </router-link>
        </li>
        <span class="header">FERRAMENTAS</span>
        <li
          :class="
            this.$route.path === '/ferraments-url' ? 'active-navigation' : ''
          "
        >
          <router-link to="/ferraments-url" class="d-flex align-center">
            <i class="iconMenu icon-global" />
            <span> Url </span>
          </router-link>
        </li>
        <li
          :class="this.$route.path === '/teste-ab' ? 'active-navigation' : ''"
        >
          <router-link to="/teste-ab" class="d-flex align-center">
            <i class="iconMenu icon-global" />
            <span>Teste AB </span>
          </router-link>
        </li>
        <span class="header">PARÂMETROS</span>
        <li
          :class="
            this.$route.path === '/disparos-automaticos'
              ? 'active-navigation'
              : ''
          "
        >
          <router-link to="/disparos-automaticos" class="d-flex align-center">
            <i class="iconMenu icon-clock" />
            <span> Disparos Automáticos </span>
          </router-link>
        </li>
        <span class="header">FACEBOOK</span>
        <li
          :class="
            this.$route.path === '/facebook'
              ? 'active-navigation'
              : ''
          "
        >
          <router-link to="/facebook" class="d-flex align-center">
            <i class="iconMenu icon-facebook" />
            <span> Formulário </span>
          </router-link>
        </li>
      </ul>
      <ul class="sidebar-navigation footer" :style="openMenu ? 'margin-left: 0px;' : 'margin-left: -30px'">
        <li class="mt-3 d-flex align-center">
          <button @click="logout()" class="d-flex align-items btnLogout">
            <img  class="iconMenuLogout" src="../../static/images/logout.svg" />
            <span v-if="openMenu" class="pl-6">Logout</span>
          </button>
        </li>
      </ul>
    </div>

    <div>
      <Content />
    </div>
  </div>
</template>
<script>
// Lib
import { mapActions } from "vuex";
import VueCookies from "vue-cookies";

// Componets
import Content from "../components/Content.vue";

export default {
  components: { Content },
  data() {
    return {
      menu: true,
    };
  },
  computed: {
    openMenu() {
      return this.$route.path != "/dashboard";
    },
    menuReduced() {
      return this.$route.path != "/dashboard" || !this.menu
        ? "width: 333px;"
        : "width: 92px;";
    },
  },
  methods: {
    ...mapActions("Users", ["userLogout"]),
    async logout() {
      try {
        const token = VueCookies.get("jwt-login");
        await this.userLogout(token);
        VueCookies.remove("jwt-login");
        this.$router.push({
          name: "Login",
        });
      } catch (error) {
        this.$router.push({
          name: "Login",
        });
      }
    },
  },
};
</script>
<style lang="">
.btnLogout {
  width: 320px;
}

body::-webkit-scrollbar {
  width: 12px;               /* width of the entire scrollbar */
}

body::-webkit-scrollbar-track {
  background: #F6F5F6;        /* color of the tracking area */
}

body::-webkit-scrollbar-thumb {
  background-color: #1D1E25;    /* color of the scroll thumb */
  border-radius: 20px;       /* roundness of the scroll thumb */
  border: 3px solid #F6F5F6;  /* creates padding around scroll thumb */
}

.sidebar-container {
  position: fixed;
  height: 100%;
  left: 0;
  overflow-x: hidden;
  overflow-y: auto;
  background: var(--default-black);
  color: var(--white);
  transition: all 0.5s ease;
  border-radius: 0px 4px 4px 0px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.sidebar-container::-webkit-scrollbar {
  width: 12px;               /* width of the entire scrollbar */
}

.sidebar-container::-webkit-scrollbar-track {
  background: #F6F5F6;        /* color of the tracking area */
}

.sidebar-container::-webkit-scrollbar-thumb {
  background-color: #1D1E25;    /* color of the scroll thumb */
  border-radius: 20px;       /* roundness of the scroll thumb */
  border: 3px solid #F6F5F6;  /* creates padding around scroll thumb */
}



.sidebar-logo {
  padding-top: 82px;
  font-size: 20px;
}

ul {
  padding-left: 0px !important;
}

.sidebar-navigation {
  padding: 0;
  margin: 0;
  list-style-type: none;
  position: relative;
  padding-left: 0px !important;

}

.footer {
  margin-left: -30px;
  margin-bottom: 15px;
}

.sidebar-navigation li {
  background-color: transparent;
  position: relative;
  display: inline-block;
  width: 100%;
  line-height: 20px;
  height: 52px;
}

.sidebar-navigation li a span {
  padding: 15px 0 13px 26px;
  display: block;
  color: var(--white);
  font-size: 14px;
}

.sidebar-navigation li::before {
  background-color: var(--black-090);
  position: absolute;
  content: "";
  height: 100%;
  left: 0;
  top: 0;
  -webkit-transition: width 0.2s ease-in;
  transition: width 0.2s ease-in;
  width: 3px;
  z-index: -1;
}

.sidebar-navigation li:hover::before {
  width: 100%;
  /* border-left: 3px solid var(--dark-red); */
}

.active-navigation {
  background-color: var(--black-090) !important;
  border-left: 3px solid var(--dark-red);
}

.sidebar-navigation .header {
  font-size: 12.64px;
  line-height: 16.85px;
  text-transform: uppercase;
  padding: 30px 0 10px 38px;
  display: flex;
  align-items: center;
}

.sidebar-navigation .header::before {
  background-color: transparent;
}

.iconMenu {
  padding-left: 65px;
  color: var(--white);
  font-size: 20px;
}

.iconMenuLogout {
  padding-left: 61px;
  color: var(--white);
  font-size: 20px;
}
</style>


// WEBPACK FOOTER //
// src/views/Home.vue